<template>
	<div v-if="!file">
		<div :class="['dropZone', dragging ? 'dropZone-over' : '']" @dragenter="dragging = true" @dragleave="dragging = false">
			<div class="dropZone-info" @drag="onChange">
				<span class="fa fa-cloud-upload dropZone-title"></span>
				<span v-if="type==='image'">
<!--				  <img src="/image/logo.png" v-if="!showPreview && form.photo==null " style="height:5em">-->
				</span>

				<span  class="dropZone-title">Перетащите файл для загрузки
				<spn v-if="type==='image'"> изображения</spn>
				<spn v-if="type==='rpm'"> приложения</spn>
				</span>
				<div  class="dropZone-upload-limit-info">
					<div>Максимальный размер: 5 MB</div>
				</div>
			</div>
			<input type="file" @change="onChange">
		</div>
	</div>

	<div v-else class="dropZone-uploaded">
		<button type="button" class="btn btn-danger btn-sm" @click="removeFile">x</button>
		<div class="dropZone-uploaded-info">
			<span v-if="type == 'image'">
							<img v-bind:src="imagePreview" style="height:5em" v-show="showPreview">
			</span>
			<span v-else class="dropZone-title">Uploaded</span>
		</div>
		<div class="uploadedFile-info" v-if="type==='rpm'">
			<div> Имя: {{ file.name }}</div>
			<div> Размер(кб): <span v-if="file.size">{{ (Number(file.size)/1024).toFixed(2) }}</span> </div>
			<!--		<div>extension：{{ extension }}</div>-->
		</div>
	</div>


</template>

<script>
export default {
	props: [
		'type','imageSrc','size'
	],
	data () {
		return {
			file: '',
			showPreview: false,
			imagePreview: false,
			dragging: false
		}
	},
	methods: {
		onChange(e) {
			var input = e.target || e.dataTransfer;
			if (!input.files.length) {
				this.dragging = false;
				return;
			}
			this.createFile(input.files[0]);
		},
		createFile(file) {
			if (file.type!='' && this.type==='rpm'){
				alert('Не корректный тип файла, должен быть ' + this.type +'');
				this.dragging = false;
				return;
			}
			if (file.type==='' && this.type!='rpm'){
				alert('Не корректный тип файла, должен быть ' + this.type +'');
				this.dragging = false;
				return;
			}
			if (file.size > 12000000) {
				alert('Превышен размер 120 MB.')
				this.dragging = false;
				return;
			}
			this.file = file;
			if (this.type == 'image') {
				//this.file = this.files;
				var reader = new FileReader();
				reader.addEventListener("load", function () {
					this.showPreview = true;
					this.imagePreview = reader.result;
				}.bind(this), false);
				if (this.file) {
					if (/\.(jpe?g|png|gif)$/i.test(this.file.name)) {
						reader.readAsDataURL(this.file);
					}
				}
			}
			this.$emit('file', file);

			//console.log(this.file);
			this.dragging = false;

		},
		removeFile() {
			this.file = '';
			this.dragging=false;
		}
	},
	computed: {
		extension() {
			return (this.file) ? this.file.name.split('.').pop() : '';
		}
	}

}
</script>
<style>
.btn{
	text-align: right!important;
}
.dropZone {
	width: auto;
	height: 200px;
	position: relative;
	border: 2px dashed #eee;
}

.dropZone:hover {
	border: 2px solid #2e94c4;
}

.dropZone:hover .dropZone-title {
	color: #1975A0;
}

.dropZone-info {
	color: #A8A8A8;
	position: absolute;
	top: 50%;
	width: 100%;
	transform: translate(0, -50%);
	text-align: center;
}

.dropZone-title {
	color: #787878;
}

.dropZone input {
	position: absolute;
	cursor: pointer;
	top: 0px;
	right: 0;
	bottom: 0;
	left: 0;
	width: 100%;
	height: 100%;
	opacity: 0;
}

.dropZone-upload-limit-info {
	display: flex;
	justify-content: flex-start;
	flex-direction: column;
}

.dropZone-over {
	background: #5C5C5C;
	opacity: 0.8;
}

.dropZone-uploaded {
	width: auto;
	height: 200px;
	position: relative;
	border: 2px dashed #eee;
}

.dropZone-uploaded-info {
	display: flex;
	flex-direction: column;
	align-items: center;
	color: #A8A8A8;
	position: absolute;
	top: 50%;
	width: 100%;
	transform: translate(0, -50%);
	text-align: center;
}

.removeFile {
	width: 200px;
}

</style>